var map = {
	"./symbol_0.png": "80ee",
	"./symbol_1.png": "7ecf",
	"./symbol_10.png": "83f6",
	"./symbol_11.png": "6160",
	"./symbol_12.png": "50ef",
	"./symbol_13.png": "aece",
	"./symbol_14.png": "52ac",
	"./symbol_15.png": "19e4",
	"./symbol_16.png": "caa7",
	"./symbol_17.png": "f7c3",
	"./symbol_2.png": "c7c2",
	"./symbol_3.png": "d0dc",
	"./symbol_4.png": "b313",
	"./symbol_5.png": "5678",
	"./symbol_6.png": "010c",
	"./symbol_7.png": "4dd8",
	"./symbol_8.png": "cdeb",
	"./symbol_9.png": "2949"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b24e";